import { useEffect, useRef, useState } from "react";
import { ThemenSlide } from "./ThemenSlide";
import { VoteTallyBoard } from "./VoteTallyBoard";
import { usePhase } from "@/state/store";

type Tab = "themen" | "ergebnisse";

export function PresenterTopicsView() {
  const phase = usePhase();
  // Auto-switch to "ergebnisse" when voting opens — but only ONCE per
  // entry into the voting phase. If the operator manually clicks back to
  // "themen" we must not yank them away again on the next render.
  const [tab, setTab] = useState<Tab>(phase === "voting" ? "ergebnisse" : "themen");
  const userOverride = useRef(false);

  useEffect(() => {
    if (phase === "voting" && !userOverride.current) {
      setTab("ergebnisse");
    }
    if (phase !== "voting") {
      // Reset the override when we leave voting, so re-entering still
      // auto-switches as expected.
      userOverride.current = false;
    }
  }, [phase]);

  const onTabClick = (next: Tab) => {
    userOverride.current = true;
    setTab(next);
  };

  return (
    <div className="topics-view-root">
      {/* Floating tab switcher — visible on top of the slide */}
      <div role="tablist" className="topics-tab-floater admin-tablist">
        <button
          role="tab"
          type="button"
          aria-selected={tab === "themen"}
          className={`admin-tab${tab === "themen" ? " active" : ""}`}
          onClick={() => onTabClick("themen")}
        >
          Themen für heute
        </button>
        <button
          role="tab"
          type="button"
          aria-selected={tab === "ergebnisse"}
          className={`admin-tab${tab === "ergebnisse" ? " active" : ""}`}
          onClick={() => onTabClick("ergebnisse")}
        >
          <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
            Ergebnisse
            {phase === "voting" && (
              <span className="topics-live-badge">live</span>
            )}
          </span>
        </button>
      </div>

      {tab === "themen" ? (
        <ThemenSlide />
      ) : (
        <div className="topics-results-shell">
          <header className="rise rise-1" style={{ marginBottom: 24 }}>
            <div className="deck-eyebrow">Workshop · Themen</div>
            <h1
              className="deck-title"
              style={{ fontSize: "clamp(2rem, 4vw, 3rem)" }}
            >
              Live-<span className="accent">Abstimmung</span>
            </h1>
          </header>
          <div className="rise rise-2">
            <VoteTallyBoard />
          </div>
        </div>
      )}
    </div>
  );
}
